
import { Component, Vue } from 'vue-property-decorator'

import Categories from '@/components/Categories.vue'
import '@/theme/scss/components/item.scss'
import '@/theme/scss/modals/login.scss'
import '@/theme/scss/modals/register.scss'
import '@/theme/scss/modals/itemModal.scss'
import '@/theme/scss/pages/index.scss'
import '@/theme/scss/modals/checkoutModal.scss'
import '@/theme/scss/components/_sector.scss'

import LoginModal from '@/modules/user/LoginModal.vue'
import RegisterModal from '@/modules/user/RegisterModal.vue'
import Sectors from './Sectors.vue'
import ProductsInOffer from './ProductsInOffer.vue'
import BestDeals from './BestDeals.vue'
import FooterLayout from './Footer.vue'
import UserModule from '../../modules/headers/UserModule.vue'
import UserDropdown from '../../modules/user/UserDropdown.vue'
import Cart from '../../modules/Cart.vue'
import SearchHeader from '../../modules/headers/SearchHeader.vue'
import CheckoutModal from '../../modules/order/CheckoutModal.vue'
import ItemModal from '../../modules/ItemModal.vue'
import CategoryHeader from '../../modules/headers/CategoryHeader.vue'
import { envConfiguration } from '@/plugins/globalStaticDatas'

@Component({
  components: {
    LoginModal,
    RegisterModal,
    UserModule,
    UserDropdown,
    Cart,
    SearchHeader,
    Sectors,
    ProductsInOffer,
    BestDeals,
    FooterLayout,
    CheckoutModal,
    ItemModal,
    CategoryHeader,
    Categories,
  },
})
export default class Home extends Vue {
  envConfigurations: any = envConfiguration
}
